import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo
        title="页面不存在 | 黑料每日"
        description="你访问的页面不存在或已被移除，可以回到首页继续浏览每日早报与每日一瓜。"
        canonicalPath={location.pathname}
      />
      <section className="px-4 md:px-8 py-24 flex flex-col items-center text-center">
        <span className="font-heading text-7xl md:text-9xl font-bold text-background-200 select-none">
          404
        </span>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-4">
          这个页面还没上架
        </h1>
        <p className="mt-3 text-sm text-foreground-600 max-w-md leading-relaxed">
          你访问的地址不存在，可能是链接有误或内容已经调整。不如回首页看看今天的早报和一瓜。
        </p>
        <p className="mt-2 text-xs text-foreground-400 break-all">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 px-5 py-3 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/gossip"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 text-foreground-700 px-5 py-3 text-sm hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-fire-line" aria-hidden="true" />
            看看每日一瓜
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}